import { MouseEvent, ReactElement } from 'react';
import { useTranslate } from '@client/i18n/hooks';
import { ProductVariantOptionType, ProductVariantType } from '@client/product/redux/products/types';
import { VariantPicker } from 'b2b-components/theme/components/VariantPicker';

interface ProductVariantsProps {
  variantGroups: ProductVariantType[];
  hasSelectionError: boolean;
  onSelect: (
    event: MouseEvent<HTMLInputElement>,
    option: ProductVariantOptionType,
  ) => void;
}

export const ProductVariants = ({
  variantGroups,
  hasSelectionError,
  onSelect,
}: ProductVariantsProps): ReactElement => {
  const t = useTranslate();

  return (
    <VariantPicker
      variantGroups={variantGroups}
      hasSelectionError={hasSelectionError}
      onSelect={onSelect}
      errorMessage={t('Your selection wasn\'t available and has been modified.')}
    />
  );
};
